import {Injectable} from '@angular/core';
import {Chart, Series} from 'highcharts';

@Injectable({
  providedIn: 'root'
})
export class GaugeChartDataUpdateService {

  public updateChartData(chart: Chart, valuesArray) {

    const series: Series[] = chart.series;
    if (!this.isDataUpdatePossible(series, valuesArray)) {
      return;
    }

    const currentSeries: Series = series[0];
    const latestEntry = valuesArray[valuesArray.length - 1];
    const value = latestEntry.vs[0];
    const numericValue = Number(value.v);

    if (Number.isNaN(numericValue)) {
      return;
    }

    if (currentSeries.points && currentSeries.points[0]) {
      currentSeries.points[0].update({y: numericValue}, true, true);
    } else {
      currentSeries.setData([numericValue], true, true);
    }
  }

  private isDataUpdatePossible(series: Series[], valuesArray) {
    if (!series || series.length === 0) {
      return false;
    }

    if (!valuesArray || valuesArray.length === 0 || !valuesArray[0] || !valuesArray[0].vs || valuesArray[0].vs.length === 0) {
      return false;
    }
    return true;
  }

}
